import React, { Component } from "react";

export class TransactionSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: {
        limit: 10,
        order_by: "updatedAt",
        order_direction: "DESC",
        page: 1,
      },
    };
    this.fields = [
      {
        name: "startDate",
        label: "Start Date",
        type: "date",
        placeholder: "Start Date",
      },
      {
        name: "endDate",
        label: "End Date",
        type: "text",
        type: "date",
        placeholder: "End Date",
      },
    ];
  }

  onSearch = (reset = false) => {
    let data = this.refs.form.form.current.getData();
    console.log("onSearch formData", data, reset);
    data = Object.filter(data, (val) => val);
    this.props.onSearch && this.props.onSearch(data, reset);
  };

  resetSearchForm() {
    this.refs.form.form.current.reset();
    this.onSearch(true);
  }

  render() {
    return (
      <>
        <AppForm className="filter-row flex-auto mx-auto" ref="form">
          <div className="d-none d-xl-flex col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2"></div>
          {this.fields.map((field, i) => (
            <div className="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-2" key={i}>
              <AppInputFocus ref="inputname" {...field}></AppInputFocus>
            </div>
          ))}
          <div className="col-12 col-sm-3 col-md-2 col-lg-1 p-0 d-flex align-items-start justify-content-center">
            <button
              className="btn btn-primary search_btn"
              onClick={() => this.onSearch()}
            >
              <i className="fa fa-search"></i>
              <span>Search</span>
            </button>
          </div>
          <span
            className="clear-all text-primary"
            onClick={() => this.resetSearchForm()}
          >
            Clear All
          </span>
        </AppForm>
      </>
    );
  }
}

export default constore(TransactionSearch);
